import axios from "axios";

export async function getAddress({ commit }, params) {
  try {
    const { data } = await axios.get("/address", {
      params: params,
    });
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    throw Error(e.response.data.message || "Error al obtener direcciones");
  }
}

export async function createAddress({ commit }, payload) {
  try {
    const { data } = await axios.post("/address", payload);
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    throw Error(e.response.data.message || "Error al crear dirección");
  }
}

export async function deleteAddress({ commit }, id) {
  try {
    const { data } = await axios.delete(`/address/${id}`);
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    throw Error(e.response.data.message || "Error al eliminar dirección");
  }
}

export async function updateAddress({ commit }, { params, body }) {
  try {
    const { data } = await axios.put("/address", body, {
      params: params,
    });
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    throw Error(e.response.data.message || "Error al actualizar dirección");
  }
}
